/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Copy_To_AInputs */

const en_compare_event_groups_copy_to_a = /** @type {(inputs: Compare_Event_Groups_Copy_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy to A`)
};

const fr_compare_event_groups_copy_to_a = /** @type {(inputs: Compare_Event_Groups_Copy_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier vers A`)
};

const de_compare_event_groups_copy_to_a = /** @type {(inputs: Compare_Event_Groups_Copy_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopie an A`)
};

const it_compare_event_groups_copy_to_a = /** @type {(inputs: Compare_Event_Groups_Copy_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia su A`)
};

const ru_compare_event_groups_copy_to_a = /** @type {(inputs: Compare_Event_Groups_Copy_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать в А`)
};

const es_compare_event_groups_copy_to_a = /** @type {(inputs: Compare_Event_Groups_Copy_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar a A`)
};

const zh_cn2_compare_event_groups_copy_to_a = /** @type {(inputs: Compare_Event_Groups_Copy_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制到 A`)
};

const ja_compare_event_groups_copy_to_a = /** @type {(inputs: Compare_Event_Groups_Copy_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aにコピー`)
};

const hi_compare_event_groups_copy_to_a = /** @type {(inputs: Compare_Event_Groups_Copy_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A को कॉपी करें`)
};

const pt_pt2_compare_event_groups_copy_to_a = /** @type {(inputs: Compare_Event_Groups_Copy_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar para A`)
};

/**
* | output |
* | --- |
* | "Copy to A" |
*
* @param {Compare_Event_Groups_Copy_To_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_copy_to_a = /** @type {((inputs?: Compare_Event_Groups_Copy_To_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Copy_To_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_copy_to_a(inputs)
	if (locale === "de") return de_compare_event_groups_copy_to_a(inputs)
	if (locale === "it") return it_compare_event_groups_copy_to_a(inputs)
	if (locale === "ru") return ru_compare_event_groups_copy_to_a(inputs)
	if (locale === "es") return es_compare_event_groups_copy_to_a(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_copy_to_a(inputs)
	if (locale === "ja") return ja_compare_event_groups_copy_to_a(inputs)
	if (locale === "hi") return hi_compare_event_groups_copy_to_a(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_copy_to_a(inputs)
	return en_compare_event_groups_copy_to_a(inputs)
});